import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Supprime les jetons d'accès et d'actualisation du stockage local
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    // Redirige l'utilisateur vers la page de connexion
    navigate("/");
  }, [navigate]);

  return null; // Ce composant ne rend rien
}